<span [title]="video.getExactNumberOfViews()">
  <ng-container i18n *ngIf="!video.isLive">
    {video.views, plural, =1 {1 view} other {{{ video.views | myNumberFormatter }} views}}
  </ng-container>

  <ng-container i18n *ngIf="video.isLive">
    {video.views, plural, =1 {1 viewer} other {{{ video.views | myNumberFormatter }} viewers}}
  </ng-container>
</span>
